module.exports = "https://w.yxzs.360.cn/singleapp/simulator-site-old/img/p4_title.3c16c504.png";